<template>
  <div id="page-user-edit" class="vx-row full-page">
    <h2 class="page-title">International Invoice & Receipt Encoding ({{ fileList.length }} files)</h2>

    <div class="content-wrapper" v-if="fileList.length <= 0">

      <vx-card id="vx-card1" class="vx-col md:w-full preview-container elevated-card" style="text-align: center;">
        <p style="padding:120px" v-if="loading">Loading documents...</p>
        <p style="padding:120px" v-if="!loading">There is no file to process.</p>
      </vx-card>
    </div>
    <div class="content-wrapper" v-if="fileList.length > 0">
      <!-- Left Column: File Preview -->
      <vx-card id="vx-card1" title="File Preview" class="vx-col md:w-2/3 w-full preview-container elevated-card">
        <div v-if="currentFile" class="file-preview">
          <iframe v-if="isPdf(currentFile.name)" :src="getPreviewFile(currentFile.name)" width="100%" height="75%"
            class="full-height rounded"></iframe>
          <img v-else-if="isImage(currentFile.name)" :src="getPreviewFile(currentFile.name)" alt="File Preview"
            class="img-fluid three-quarter-height rounded shadow-lg" />
          <p v-else>Preview not available for this file type.</p>
        </div>
        <div class="navigation-buttons mt-2">
          <vs-button @click="prevFile" :disabled="currentIndex === 0" class="button-styled">Previous</vs-button>
          <!--<vs-button @click="prevFile" class="button-styled" color="danger">Delete</vs-button>-->
          {{ currentFile.name }}
          <vs-button @click="nextFile" :disabled="currentIndex >= fileList.length - 1"
            class="button-styled">Next</vs-button>
        </div>
      </vx-card>



      <!-- Right Column: Encoding Form -->
      <vx-card id="vx-card2" title="Encoding Form" class="vx-col md:w-1/3 w-full form-container elevated-card">
        <div class="mt-4 text-center">
          <vs-button type="border" color="danger" icon-pack="feather" icon="icon-aperture" disabled
            @click="confirmDeleteRecord">AI (disabled)</vs-button>
        </div>
        <form @submit.prevent="handleSubmit" class="form-styled">
          <div class="w-full mt-4">
            <label for="invoiceNumber" class="label-styled">Document Number</label>
            <input type="text" id="invoiceNumber" v-model="encodingData.invoiceNumber" class="input-field shadow-sm"
              required />
          </div>
          <div class="w-full mt-4">
            <label for="dateOfIssue" class="label-styled">Date of Issue</label>
            <datepicker v-model="encodingData.dateOfIssue" class="datepicker-styled"></datepicker>
          </div>
          <div class="w-full mt-4">
            <label for="dueDate" class="label-styled">Due Date</label>
            <datepicker v-model="encodingData.dueDate" class="datepicker-styled"></datepicker>
          </div>
          <div class="w-full mt-4">
            Currency
            <select v-model="encodingData.localCurrency" class="w-full mt-1">
              <option value="RON">RON</option>
              <option value="EUR">EUR</option>
            </select>
          </div>

          <div class="w-full mt-4 flex space-x-2">
            <div class="flex-1">
              <label for="amountHtva" class="label-styled">Amount Excl. VAT</label>
              <input type="number" id="amountHtva" v-model.number="encodingData.amountHtva"
                @input="updateValues('htva')" class="input-field shadow-sm" required />
            </div>

            <div class="flex-1">
              <label for="amountTva" class="label-styled">VAT Amount</label>
              <input type="number" id="amountTva" v-model.number="encodingData.amountTva" @input="updateValues('tva')"
                class="input-field shadow-sm" required />
            </div>

            <div class="flex-1">
              <label for="amountTtc" class="label-styled">Amount Incl. VAT</label>
              <input type="number" id="amountTtc" v-model.number="encodingData.amountTtc" @input="updateValues('ttc')"
                class="input-field shadow-sm" required />
            </div>
          </div>
          <div class="w-full mt-4">
            Budget Category
            <select v-model="encodingData.localBudgetCategory" class="w-full mt-1">
              <optgroup v-for="(group, index) in databudgetcategoryGrouped" :key="index" :label="group.title">
                <option v-for="(subItem, subIndex) in group.group" :key="subIndex" :value="subItem">
                  {{ subItem.text }}
                </option>
              </optgroup>
            </select>
          </div>
          <div class="w-full mt-4"> Force Payment Status
            <vs-switch class="mt-2 w-1/2" color="success" v-model="encodingData.isexppaid">
              <span slot="on">Force paid</span>
              <span slot="off">Not Paid</span>
            </vs-switch>
          </div>
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-8 button-styled" :color="isFormValid ? 'success' : 'danger'" :disabled="!isFormValid"
              @click="handleSubmit">Next & Save</vs-button>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      fileList: [],
      currentIndex: 0,
      loading: true,
      encodingData: {
        localBudgetCategory: null,
        file: null,
        localCurrency: 'EUR',
        invoiceNumber: '',
        isexppaid: false,
        dateOfIssue: moment().format('YYYY-MM-DD'),
        dueDate: moment().format('YYYY-MM-DD'), dateOfIssue: moment().format('YYYY-MM-DD'),
        dueDate: moment().format('YYYY-MM-DD'),
        amountHtva: null,
        amountTva: null,
        amountTtc: null,
        vatRate: 0, // 20% TVA
      },
      // Stocke le dernier champ de base modifié (HTVA ou TTC)
      lastBaseField: null,
      successMessage: '',
      errorMessage: '',


      databudgetcategoryGrouped: [
        {
          title: 'Unknown',
          group: [
            { text: '0. Unknown', value: null },
          ]
        },
        {
          title: 'Teiu',
          group: [
            { text: '1. Consumables', value: 1 },
            { text: '2. Infrastructure Construction', value: 2 },
            { text: '3. Machine Acquisition', value: 3 },
            { text: '4. Machine Repair', value: 4 },
            { text: '21. Equipment Protection', value: 21 },
          ]
        },
        {
          title: 'Forest',
          group: [
            { text: '5. Consumables', value: 5 },
            { text: '6. Machine Acquisition', value: 6 },
            { text: '7. Machine Repair', value: 7 },
            { text: '8. Services (Harvesting, Roads, etc.)', value: 8 },
          ]
        },
        {
          title: 'General Services',
          group: [
            { text: '9. HR, Marketing, Accounting, IT, Legal, Freelances, Penalties', value: 9 },
            { text: '16. Salaries & Independent', value: 16 },
            { text: '19. Bonus (Salaries)', value: 19 },
            { text: '11. Broker', value: 11 },
            { text: '99. Meal Tickets', value: 99 },
          ]
        },
        {
          title: 'Energy',
          group: [
            { text: '10. Fuel, Electricity & Oil', value: 10 },
          ]
        },
        {
          title: 'Transport',
          group: [
            { text: '12. Client Transport', value: 12 },
            { text: '13. Teiu Transport - Raw Materials', value: 13 },
            { text: '17. Teiu Transport - Finished Products', value: 17 },
          ]
        },
        {
          title: 'Raw Material',
          group: [
            { text: '14. Wood on Stand', value: 14 },
            { text: '15. Round Wood from Suppliers', value: 15 },
            { text: '18. Product from Reception', value: 18 },
          ]
        },
        {
          title: 'Other',
          group: [
            { text: '20. Travel, Duster, Touran', value: 20 },
          ]
        }
      ],
    };
  },
  computed: {
    // Check that all required fields are filled
    isFormValid() {
      const d = this.encodingData;
      return (
        d.invoiceNumber &&
        d.dateOfIssue &&
        d.dueDate &&
        d.localCurrency &&
        d.amountHtva !== null &&
        d.amountTva !== null &&
        d.amountTtc !== null &&
        d.localBudgetCategory
      );
    },
    currentFile() {
      return this.fileList[this.currentIndex];
    },
  },
  watch: {
    "encodingData.localCurrency"(newCurrency) {
      if (newCurrency === "EUR") {
        this.encodingData.vatRate = 0;
      } else if (newCurrency === "RON") {
        this.encodingData.vatRate = 0.19;
      }
      // Recalculer les montants si un montant HTVA est déjà saisi
      if (this.encodingData.amountHtva !== null) {
        this.updateValues('htva');
      }
    }
  },
  methods: {
    updateValues(champ) {
      // Si le champ modifié n'est pas TVA, on le note comme base
      if (champ !== "tva") {
        this.lastBaseField = champ;
      }
      if (champ === "htva") {
        // Saisie de HTVA : recalculer TVA et TTC
        this.encodingData.amountTva = this.round(this.encodingData.amountHtva * this.encodingData.vatRate);
        this.encodingData.amountTtc = this.round(this.encodingData.amountHtva + this.encodingData.amountTva);
      } else if (champ === "ttc") {
        // Saisie de TTC : recalculer HTVA et TVA
        this.encodingData.amountHtva = this.round(this.encodingData.amountTtc / (1 + this.encodingData.vatRate));
        this.encodingData.amountTva = this.round(this.encodingData.amountTtc - this.encodingData.amountHtva);
      } else if (champ === "tva") {
        // Saisie de TVA : ajuster selon la dernière saisie de base
        if (this.lastBaseField === "ttc" && this.encodingData.amountTtc != null) {
          // Si TTC était la base, HTVA = TTC - TVA
          this.encodingData.amountHtva = this.round(this.encodingData.amountTtc - this.encodingData.amountTva);
        } else if (this.lastBaseField === "htva" && this.encodingData.amountHtva != null) {
          // Si HTVA était la base, TTC = HTVA + TVA
          this.encodingData.amountTtc = this.round(this.encodingData.amountHtva + this.encodingData.amountTva);
        } else {
          // Par défaut, si HTVA existe, ajuster TTC
          if (this.encodingData.amountHtva != null) {
            this.encodingData.amountTtc = this.round(this.encodingData.amountHtva + this.encodingData.amountTva);
          }
        }
      }
    },
    round(val) {
      return parseFloat(Number(val).toFixed(2));
    },
    isPdf(name) {
      return /\.(pdf)$/i.test(name);
    },
    isImage(name) {
      return /\.(jpg|jpeg|png|gif)$/i.test(name);
    },
    getPreviewFile(name) {
      return `https://xylo.codesinn.com/api/filesdl/${name}`;
    },
    prevFile() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    nextFile() {
      if (this.currentIndex < this.fileList.length - 1) {
        this.currentIndex++;
      }
    },
    async fetchFiles() {
      try {
        const response = await axios.get('https://xylo.codesinn.com/api/ftp/files');
        this.fileList = response.data.filter(file => file.name !== '.ftpquota' && file.name !== 'done');
      } catch (error) {
        this.errorMessage = "Unable to fetch the file list.";
      }
    },
    async handleSubmit() {
      if (!this.isFormValid) return;
      try {
        this.encodingData.file = this.currentFile.name;
        await axios.post('https://xylo.codesinn.com/api/encodeinvoiceeu', this.encodingData);
        this.$router.go(0);
        loading = false
        this.successMessage = "Data successfully encoded.";
        this.errorMessage = '';
        await fetchFiles();
        this.resetForm(); // Réinitialise le formulaire
        await this.fetchFiles();
      } catch (error) {
        this.errorMessage = "Error encoding data.";
        this.successMessage = '';
      }
    },
    resetForm() {
      this.encodingData = {
        localBudgetCategory: null,
        file: null,
        localCurrency: 'EUR',
        invoiceNumber: '',
        isexppaid: false,
        dateOfIssue: moment().format('YYYY-MM-DD'),
        dueDate: moment().format('YYYY-MM-DD'),
        amountHtva: null,
        amountTva: null,
        amountTtc: null,
        vatRate: 0
      };
      this.lastBaseField = null;
      this.currentIndex = 0; // Affiche le premier PDF
    },
    confirmDeleteRecord() {
      console.log("AI button clicked");
    }
  },
  mounted() {
    this.fetchFiles();
  },
};
</script>

<style scoped>
select {
  width: 100%;
  padding: 0.5rem 1rem;
  border: 1px solid #d1d5db;
  /* Couleur de la bordure */
  border-radius: 0.375rem;
  /* Coins arrondis */
  background-color: #f9fafb;
  /* Couleur de fond */
  font-size: 1rem;
  color: #374151;
  /* Couleur du texte */
  appearance: none;
  /* Supprime la flèche par défaut */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  /* Ombre légère */
  transition: all 0.2s ease-in-out;
}

select:hover {
  border-color: #9ca3af;
  /* Changement de bordure au survol */
}

select:focus {
  outline: none;
  border-color: #2563eb;
  /* Couleur de bordure au focus */
  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.3);
  /* Ombre autour */
}

option {
  font-size: 1rem;
  color: #374151;
  padding: 0.5rem;
}

optgroup {
  font-weight: bold;
  color: #111827;
  /* Couleur du titre des groupes */
  padding: 0.5rem 1rem;
}

.full-page {
  height: 100vh;
  padding: 6px;
  margin: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.page-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.content-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.preview-container,
.form-container {
  height: 90vh;
  max-height: 90vh;
  padding: 2px;
  margin: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.file-preview {
  border: 1px solid #ccc;
  padding: 0px;
  height: 100%;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.full-height {
  width: 100%;
  height: 70vh;
  border: none;
}

.img-fluid.three-quarter-height {
  width: 100%;
  height: 75%;
  object-fit: contain;
}

.input-field {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.navigation-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
</style>
